import { Link } from "react-router-dom";
import { Camera, LockKey, QrCode } from "@phosphor-icons/react";

export default function HomePage() {
    return (
        <div className="min-h-screen flex items-center justify-center px-6" data-testid="home-page">
            <div className="w-full max-w-md fade-up">
                <div className="text-center mb-10">
                    <img src="/logo.png" alt="INERRE interior" className="h-12 object-contain mx-auto mb-4" data-testid="home-logo" />
                    <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">Sistem Informasi Ruangan</p>
                </div>
                <div className="space-y-3">
                    <div className="border border-border bg-white p-5" data-testid="mode-open-info">
                        <div className="flex items-center gap-4">
                            <Camera size={26} weight="light" className="text-primary shrink-0" />
                            <div>
                                <p className="font-medium text-sm">Akses Terbuka</p>
                                <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
                                    Pindai QR ruangan langsung dari kamera HP — tanpa perlu aplikasi.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Link
                        to="/supervisor"
                        data-testid="mode-supervisor-link"
                        className="block border border-border bg-white p-5 hover:border-primary hover:-translate-y-[1px] transition-all duration-200"
                    >
                        <div className="flex items-center gap-4">
                            <QrCode size={26} weight="light" className="text-primary shrink-0" />
                            <div>
                                <p className="font-medium text-sm">Mode Supervisor</p>
                                <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
                                    Buka pemindai QR untuk masuk ke view supervisor ruangan.
                                </p>
                            </div>
                        </div>
                    </Link>
                    <Link
                        to="/admin"
                        data-testid="mode-admin-link"
                        className="block border border-border bg-white p-5 hover:border-primary hover:-translate-y-[1px] transition-all duration-200"
                    >
                        <div className="flex items-center gap-4">
                            <LockKey size={26} weight="light" className="text-primary shrink-0" />
                            <div>
                                <p className="font-medium text-sm">Mode Admin</p>
                                <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
                                    Frasa rahasia, lalu pindai QR untuk masuk ke view admin ruangan.
                                </p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}
